export default __webpack_public_path__ + "d1d7ada3e7e44227e5787047e737d96a.png";